import { LOCAL_STORAGE_KEYS, PAGE_URL } from "@/data_source/constants";
import { ProjectSelectedStore } from "@/stores/project-selected-store";
import { ProjectsStore } from "@/stores/projects-store";
import { UserStore } from "@/stores/user-store";
import { WorkspaceContextStore } from "@/stores/workspace-context-store";
import request, {
  abortPendingRequests,
  registerUnauthorizedResponseHandler,
  SKIP_AUTH_EXPIRATION_HEADER
} from "@/utils/request";
import { RequestCacheBuilder } from "@/utils/request/cache";
import { clearSentryContext } from "@/utils/sentry/user-context";

export const clearAuthState = () => {
  abortPendingRequests();
  RequestCacheBuilder.getInstance().clear();
  UserStore.getInstance().add(null);
  ProjectSelectedStore.getInstance().add(null);
  ProjectsStore.getInstance().add([]);
  WorkspaceContextStore.getInstance().reset();
  clearSentryContext();
  localStorage.removeItem(LOCAL_STORAGE_KEYS.VISITED_LOBBY);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem("token");
  request.setGlobalHeader({
    Authorization: ""
  });
  document.cookie =
    "auth_token=; Path=/; Domain=.sitehubpro.com; Max-Age=0; SameSite=Lax; Secure";
  window.location.assign(PAGE_URL.SIGN_IN);
};

export const logout = (): Promise<void> => {
  const refreshToken = localStorage.getItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);

  if (!refreshToken) {
    clearAuthState();
    return Promise.resolve();
  }

  return request
    .postRequest(
      "api/token/blacklist/",
      { refresh: refreshToken },
      {
        "content-type": "application/json",
        [SKIP_AUTH_EXPIRATION_HEADER]: "true"
      }
    )()
    .response.then(() => undefined)
    .catch(() => undefined)
    .finally(clearAuthState);
};

let expirationPromise: Promise<void> | null = null;

export const expireAuthenticatedSession = (): Promise<void> => {
  if (expirationPromise) return expirationPromise;

  expirationPromise = Promise.resolve()
    .then(() => logout())
    .finally(() => {
      expirationPromise = null;
    });
  return expirationPromise;
};

export const initializeAuthExpirationHandling = (): void => {
  registerUnauthorizedResponseHandler(() => {
    void expireAuthenticatedSession();
  });
};
